import { useState, useEffect, useContext } from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { Form, Button, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import DatePicker from "react-datepicker"; // Import react-datepicker
import "react-datepicker/dist/react-datepicker.css"; // Import stylów dla kalendarza
import { addDays, isAfter } from "date-fns"; // Narzędzia do pracy z datami
import { format } from "date-fns";

// Walidacja w schemacie Yup, z walidacją daty większej niż dzisiejsza
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Nieprawidłowy adres email")
    .required("Email jest wymagany"),
});

export default function AddGroupOwnerEmail() {
  const { userData } = useContext(UserDataContext);
  const [error, setError] = useState();
  const [errorText, setErrorText] = useState("");
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await axios.post(
        API_URL + `/addgroupowneremail/${userData.cookie}`,
        values
      );
      setError(response.data.error_msg);
      console.log(response.data.error_msg);
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };
  useEffect(() => {
    if (error === 501) {
      setErrorText("Taki właściciel już istnieje");
    }
    if (error === 200) {
      setErrorText("Email właściciela przekazany do zapisu");
      navigate(0);
    }
  }, [error]);

  useEffect(() => {
    const fetchData = async () => {
      const url = API_URL + `/users/${userData.cookie}`;
      try {
        const response = await axios.get(url);
        setData(response.data);
      } catch (error) {
        setError(error.message);
      }
    };

    if (userData && userData.userId) {
      fetchData();
      const intervalId = setInterval(fetchData, 100000);
      return () => clearInterval(intervalId);
    }
  }, [userData]);

  return (
    <Row className="justify-content-md-center">
      <Col md={12}>
        <h2>Rejestracja email właściciela grupy</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, setFieldValue, values }) => (
            <FormikForm>
              <Form.Group controlId="formUser">
                <Form.Label>Wpisz email właściciela grupy</Form.Label>
                <Field name="email" type="text" className="form-control" />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger"
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                Rejestruj
              </Button>
            </FormikForm>
          )}
        </Formik>
      </Col>
      {errorText}
    </Row>
  );
}
